
<app-spinner>
<div class="line">
    <div class="headermob">
        <button mat-icon-button class="buttontool" (click)="back()">
            <mat-icon class="btn-iconBlack">arrow_back</mat-icon>
        </button>
        <button mat-icon-button class="buttontool" (click)="home()">
            <mat-icon class="btn-iconBlack">home</mat-icon>
        </button>
        <button mat-icon-button (click)="Showcart()" class="buttontool">
            <mat-icon class="btn-iconBlack"  [matBadge]="cartCount" matBadgePosition="above after" matBadgeSize="small">shopping_cart</mat-icon>
        </button>
    </div>
</div>
<div class="mobilelayout" *ngIf="Menu">
    <mat-panel-title class="titlemob">
        Our food offerings for {{eventName}}
    </mat-panel-title>
    <div class="example-ripple-container mat-elevation-z4" matRipple *ngFor="let item of foodtype"
        (click)="LoadMenu(item)">
        <div>
            <div>
                <img mat-card-image class="ripple-imagemob" [src]="item.image" alt="{{item.text}}">
            </div>
            <div>
                <mat-panel-title class="titleboxmob">
                    {{item.text}}
                </mat-panel-title>
            </div>
            <div>
                <mat-panel-title class="titlemob">Item Count: {{item.itemcount}}</mat-panel-title>
            </div>
        </div>
    </div>
</div>
<div class="mobilelayout" *ngIf="MenuItem">
    <mat-panel-title class="titlemob">
        Our selection of {{selectedtype}}
    </mat-panel-title>
    <mat-accordion *ngFor="let item of welcomedrink">
        <div class="cardmob">
            <div class="leftmob">
                <mat-expansion-panel class="panelmob">
                    <mat-expansion-panel-header collapsedHeight="40px">
                        <mat-panel-title>
                            {{item.foodname}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <img mat-card-image [src]="item.foodimage" alt="{{item.foodname}}" class="panelimage">
                    <p>{{item.fooddesc}}</p>
                </mat-expansion-panel>
            </div>
            <div class="rightmob">
                <button mat-icon-button (click)="addToMenu(item)" class="buttonmenu">
                    <mat-icon inline="false" class="btn-iconOrange">add</mat-icon>
                </button>

            </div>
        </div>
    </mat-accordion>

</div>

<div class="mobilelayout" *ngIf="Cart">
    <div>
        <div class="mymenutoolbar">
            <mat-panel-title class="titlemob">
                Your Custom Menu for {{selectedtype}}
            </mat-panel-title>
            <div class="headermob">
                <button mat-icon-button class="buttontool" matTooltip="Download">
                    <mat-icon class="btn-iconBlack" (click)="mobiledownload()">download</mat-icon>
                </button>
                <!-- <button mat-icon-button class="buttontool">
                    <mat-icon class="btn-iconBlack">share</mat-icon>
                </button>
                <button mat-icon-button class="buttontool">
                    <mat-icon class="btn-iconBlack">print</mat-icon>
                </button> -->
                <button mat-icon-button class="buttontool">
                    <mat-icon class="btn-iconBlack">delete</mat-icon>
                </button>
            </div>
        </div>
        <div id="print">
            <mat-accordion *ngFor="let item of selectedItems">
                <div class="cardmob">
                    <div class="leftmob">
                        <mat-expansion-panel class="panelmob">
                            <mat-expansion-panel-header collapsedHeight="40px">
                                <mat-panel-title>
                                    {{selectedItems.indexOf(item)+1}} -- {{item.foodtype}} -- {{item.foodname}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <img mat-card-image [src]="item.foodimage" alt="{{item.foodname}}" class="panelimage">

                        </mat-expansion-panel>
                    </div>
                    <div class="rightmob">
                        <button mat-icon-button (click)="removeFromMenu(item)" class="buttonmenu">
                            <mat-icon class="btn-iconOrange" inline="false">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-accordion>
        </div>
    </div>

</div>
<div class="mobilelayout" *ngIf="dialog">
    <div>
        <img class="downloadimg" src="assets/images/popup.png">
        <p class="titledownload">Please provide the following information to let SpiceTrail help you </p>
        <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Your Name</mat-label>
            <input matInput type="text" [(ngModel)]="name" #nameInput="ngModel" required>
            @if (name) {
            <button matSuffix mat-icon-button (click)="name=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
            <mat-error *ngIf="nameInput.invalid && nameInput.touched">
                Name is required.
            </mat-error>
        </mat-form-field>
               <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Tentative number of guests</mat-label>
            <input matInput type="number" [(ngModel)]="pax" #paxInput="ngModel" required>
            @if (pax) {
            <button matSuffix mat-icon-button (click)="pax=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
            <mat-error *ngIf="paxInput.invalid && paxInput.touched">
                Number of heads is required.
            </mat-error>
        </mat-form-field>
        <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Venue if decided or Location</mat-label>
            <input matInput type="text" [(ngModel)]="location"  #locationInput="ngModel" required>
            @if (location) {
            <button matSuffix mat-icon-button (click)="location=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
            <mat-error *ngIf="locationInput.invalid && locationInput.touched">
                Location is required.
            </mat-error>
        </mat-form-field>
        <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Tentative date of the event</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="date" name="date" #dateInput="ngModel" required>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="dateInput.invalid && dateInput.touched">
                Please select a date.
            </mat-error>
        </mat-form-field>
    <div class="channel-selection-toggle">
        <span class="channel-label" [class.active]="channel === 'SMS'">SMS</span>
        <mat-slide-toggle color="primary" [(ngModel)]="isWhatsapp" (change)="channel = isWhatsapp ? 'WHATSAPP' : 'SMS'" name="channelToggle">
            
        </mat-slide-toggle>
        <span class="channel-label" [class.active]="channel === 'Whatsapp'">Whatsapp</span>
    </div>
        <mat-form-field class="mobfieldphone">
            <mat-label class="fieldtext">Enter your Phone No to get OTP</mat-label>
            <input matInput type="number" [(ngModel)]="phone">
            @if (phone) {
            <button matSuffix mat-icon-button (click)="phone=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>
        <button class="btn-icon" (click)="sendOTP()" class="fieldbutton">
            <mat-icon>textsms</mat-icon>
        </button>
        <mat-form-field class="mobfieldphone" >
            <mat-label class="fieldtext">Enter OTP here and download your menu</mat-label>
            <input matInput type="number" [(ngModel)]="otp">
            @if (otp) {
            <button matSuffix mat-icon-button (click)="otp=''" class="fieldsuffix" >
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>
        <button class="btn-icon" (click)="startdownload()" class="fieldbutton" [disabled]="!verificationID">
            <mat-icon>picture_as_pdf</mat-icon>
       
        </button>
    </div>
</div>

</app-spinner>


